import { BaseApiService } from './baseApiService';

/**
 * Service for support ticket operations
 */
class TicketService extends BaseApiService {
  async getTickets(params?: {
    status?: string;
    category?: string;
    page?: number;
    pageSize?: number;
  }) {
    await this.ensureInitialized();
    const searchParams = new URLSearchParams(params as Record<string, string>);
    const response = await this.api.get(`/ticket?${searchParams.toString()}`);
    return response.data;
  }

  async getTicket(ticketId: number) {
    await this.ensureInitialized();
    const response = await this.api.get(`/ticket/${ticketId}`);
    return response.data;
  }

  async createTicket(ticketData: {
    subject: string;
    category: string;
    priority?: string;
    description: string;
  }) {
    await this.ensureInitialized();
    const response = await this.api.post('/ticket', ticketData);
    return response.data;
  }

  async addTicketMessage(ticketId: number, messageData: { message: string }) {
    await this.ensureInitialized();
    const response = await this.api.post(
      `/ticket/${ticketId}/message`,
      messageData
    );
    return response.data;
  }
}

export const ticketService = new TicketService();
export default ticketService;
